const language = localStorage.getItem('LANG');

export const get = (env) => {
    try {
        return process.env[`REACT_APP_${language}_${env}`];
    } catch(error) {
        return process.env[`REACT_APP_EN_${env}`];
    }
}


// WEBPACK FOOTER //
// ./src/Language.js